const i18n_fields = {
  EN: [
    { key: 'created_at', label: 'DateTime', sortable: false },
    { key: 'is_valid', label: 'Result', sortable: false },
    { key: 'addr', label: 'Address', sortable: false },
    { key: 'reason', label: 'Reason', sortable: false },
    { key: 'agent', label: 'Agent', sortable: false },
  ],
  KO: [
    { key: 'created_at', label: '시각', sortable: false },
    { key: 'is_valid', label: '응답', sortable: false },
    { key: 'addr', label: 'IP 주소', sortable: false },
    { key: 'reason', label: '사유', sortable: false },
    { key: 'agent', label: '요청 브라우저', sortable: false },
  ],
  JP: [
    { key: 'created_at', label: '日付/時間', sortable: false },
    { key: 'is_valid', label: '結果', sortable: false },
    { key: 'addr', label: '住所', sortable: false },
    { key: 'reason', label: '理由', sortable: false },
    { key: 'agent', label: 'エージョント', sortable: false },
  ]
}

const fields = { i18n_fields }

export default fields